// Mocks
import { 
        MockCategoriesMarketPlaceService, 
        MockPurchaseReconciliation,
        MockRecoverForgottenPass,
        MockChangenPassSecurity,
        MockPasswordService,
        MockStarAssignment,
        MockLoginService,
        MockRecognition,
        MockUserAdmin,
        MockSuppliers,
        MockCompanies,
        MockNovelties,
        MockHapiness,
        MockProducts,
        MockReports,
        MockBonus,
        MockHome,
        } from '../mocks/services';

// Services
import { service as _CategoriesMarketPlaceService } from './categories_marketplace_service';
import { service as _recoverForgottenPass } from './recover_forgotten_password_service';
import { service as _purchaseReconciliation } from './purchase_reconciliation_service';
import { service as _changePassSecurity } from './change_password_security_services';
import { service as _starAssignment } from './star_assignment_service';
import { service as _userAdminService } from './users_admin_service';
import { service as _PasswordService } from "./password_service";
import { service as _recognition } from './recognition_service';
import { service as _suppliers } from './suppliers_services';
import { service as _companies } from './companies_services';
import { service as _novelties } from './novelties_services';
import { service as _LoginService } from "./login_service";
import { service as _hapiness } from './hapiness_services';
import { service as _products } from './product_service';
import { service as _reports } from './reports_service';
import { service as _bonus } from './bonus_services';
import { service as _home } from './home_services';

//const isMock = true;
const isMock = process.env.NODE_ENV === 'mock';
const CategoriesMarketPlaceService = !isMock ? _CategoriesMarketPlaceService : MockCategoriesMarketPlaceService;
const PurchaseReconciliationService = !isMock ? _purchaseReconciliation : MockPurchaseReconciliation;
const changePassSecurityService = !isMock ? _changePassSecurity : MockChangenPassSecurity;
const recoverForgottenPass = !isMock ? _recoverForgottenPass : MockRecoverForgottenPass;
const StarAssignmentService = !isMock ? _starAssignment : MockStarAssignment;
const PasswordService = !isMock ? _PasswordService : MockPasswordService;
const userAdminService = !isMock ? _userAdminService : MockUserAdmin;
const recognitionService = !isMock ? _recognition : MockRecognition;
const LoginService = !isMock ? _LoginService : MockLoginService;
const SuppliersService = !isMock ? _suppliers : MockSuppliers;
const CompaniesService = !isMock ? _companies : MockCompanies;
const NoveltiesService = !isMock ? _novelties : MockNovelties;
const ProductsService = !isMock ? _products : MockProducts;
const HapinessService = !isMock ? _hapiness : MockHapiness;
const reportsService = !isMock ? _reports : MockReports;
const BonusService = !isMock ? _bonus : MockBonus;
const HomeService = !isMock ? _home : MockHome;

export { 
        PurchaseReconciliationService,
        CategoriesMarketPlaceService, 
        changePassSecurityService,
        StarAssignmentService,
        recoverForgottenPass,
        recognitionService,
        userAdminService, 
        SuppliersService,
        CompaniesService,
        NoveltiesService,
        PasswordService,
        ProductsService,
        HapinessService,
        reportsService,
        BonusService,
        LoginService,
        HomeService,
 };
